export default {
  app: {
    golf: {
      title: '코스 정보',
      hasEVChargingPoint: '전기차 충전소',
      hasCaddieService: '캐디 서비스',
      hasTrolley: '트롤리',
      hasBuggy: '버기',
      hasClubRental: '클럽 대여',
      hasAcademy: '아카데미',
      hasMarshal: '마샬',
      hasPGACertification: 'PGA 인증',
      hasTrainingArea: '연습장',
      hasRestaurant: '레스토랑',
      hasHotel: '호텔',
      hasDogsOnCourse: '코스 내 반려견 허용',
      numberOfHoles: '홀 수',
    },
  },
};
